import styles from './index.module.scss'
import finishSvg from '@/assets/images/card-task-finish.png'
import failedSvg from '@/assets/images/tab-icon-failed.svg'
import loadingSvg from '@/assets/images/card-task-loading.svg'
import cn from 'classnames'
import LottieLoading from '@/components/lottie-loading'

interface TextCardProps {
  title?: string
  text?: string
  status: number
}

const IMAGE_PLACEHOLDER_KEYS = [0, 1, 2, 3] as const

/** 每张占位底色（接近设计稿灰蓝底） */
const PH_BASE_CLASSES = [styles.phBase0, styles.phBase1, styles.phBase2, styles.phBase3] as const

/** 底层深色/补色，托住上层高光 */
const MESH_DEEP_CLASSES = [
  styles.meshDeep0,
  styles.meshDeep1,
  styles.meshDeep2,
  styles.meshDeep3
] as const

const MESH_VARIANT_CLASSES = [
  styles.meshVariant0,
  styles.meshVariant1,
  styles.meshVariant2,
  styles.meshVariant3
] as const

const MESH_LAYER2_CLASSES = [
  styles.meshVariant2_0,
  styles.meshVariant2_1,
  styles.meshVariant2_2,
  styles.meshVariant2_3
] as const

/** 每张图内部独立漂移的柔光光圈（非整图横向扫光） */
const MESH_ORB_CLASSES = [
  styles.meshOrb0,
  styles.meshOrb1,
  styles.meshOrb2,
  styles.meshOrb3
] as const

const TextCard = (props: TextCardProps) => {
  const title = props.title || ''
  const { status } = props

  const statusMap: Record<number, string> = {
    0: loadingSvg,
    1: loadingSvg,
    2: finishSvg,
    3: failedSvg
  }

  const isLoading = status === 0 || status === 1

  return (
    <div
      className={cn({
        [styles.loadingCard]: isLoading,
        [styles.container]: !isLoading
      })}
    >
      <div className={styles.header}>
        {isLoading ? (
          <div className={styles.icon}>
            <LottieLoading width={20} height={20} />
          </div>
        ) : (
          <img
            className={cn(styles.icon, {
              [styles.loading]: isLoading
            })}
            src={statusMap[status]}
            alt=""
          />
        )}
        <span className={styles.title}>{title}</span>
      </div>

      {isLoading ? (
        <div className={styles.imageRowWrap}>
          <div className={styles.imageRow} aria-hidden>
            {IMAGE_PLACEHOLDER_KEYS.map(i => (
              <div key={i} className={cn(styles.imagePlaceholder, PH_BASE_CLASSES[i])}>
                <div className={cn(styles.meshDeep, MESH_DEEP_CLASSES[i])} />
                <div className={cn(styles.meshLayer, MESH_VARIANT_CLASSES[i])} />
                <div className={cn(styles.meshLayer2, MESH_LAYER2_CLASSES[i])} />
                <div className={cn(styles.meshOrb, MESH_ORB_CLASSES[i])} />
                {i === 3 ? <div className={styles.meshHotspot} /> : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default TextCard
